import { Directive, forwardRef, Input, OnChanges, SimpleChanges, Type } from '@angular/core';
import { NG_VALIDATORS, Validator, ValidationErrors, FormControl } from '@angular/forms';
import { MarketType } from '../../domain/market.domain';
import { AutoSuggestSymbol } from '../../domain/symbol-lookup.domain';
import { SymbolLookupComponent } from './symbol-lookup.component';

@Directive({
  selector: '[tdWbSymbolLookupValidator]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: forwardRef((): Type<SymbolLookupValidatorDirective> => SymbolLookupValidatorDirective),
    multi: true
  }]
})
export class SymbolLookupValidatorDirective implements Validator, OnChanges {
  @Input('tdWbSymbolLookupValidator') symbol: SymbolLookupComponent<AutoSuggestSymbol>;
  private onChange: () => void;

  validate(formControl: FormControl): ValidationErrors | null {

    if (this.symbol.checkSymbol &&
      !this.isValid(formControl.value, this.symbol.symbolInput, this.symbol.market)) {
      return { invalid : true };
    }
    return null;
  }

  registerOnValidatorChange(fn: () => void): void {
    this.onChange = fn;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes !== undefined && this.onChange !== undefined) {
      this.onChange();
    }
  }

  private isValid(enteredSymbol: AutoSuggestSymbol, enteredSymbolInput: string, market: MarketType): boolean {
    if ((enteredSymbolInput !== null && enteredSymbolInput !== '' && enteredSymbolInput !== undefined) &&
      (enteredSymbol === null || enteredSymbol === undefined)) {
      return false;
    }
    if (enteredSymbol !== null && enteredSymbol !== undefined && market !== undefined) {
      return enteredSymbol.market === market;
    }
    return true;
  }
}
